/* eslint-disable */
import React, { useCallback } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import Logo from '../../assets/img/logo.png';
import { isSubAdmin } from '../../utils/AdminAuth.utils';

//import Logo from "../assets/img/logo.png";
function Header() {
  const pathName = useLocation().pathname;
  const navigate = useNavigate();
  const isLoginPage = /^\/login\/?$/i.test(pathName);
  const isAuthenticated = Boolean(localStorage.getItem('adminSession')) || localStorage.getItem('isLoggedIn') === 'true';
  const isCurrentSubAdmin = isSubAdmin();
  const frontWebUrl = process.env.REACT_APP_WEB_URL || 'https://www.alan-ai.com';
  //상단 Gnb
  const gnbData = [
    // { title: "환경설정", link: "/Setting/Manager/Admin" },
    { title: '회원 관리', link: '/Member/MemberManage' },
    // { title: "시술관리", link: "/Product/Category/CategoryManage" },
    // { title: "예약관리", link: "/Reserve/ReserveList" },
    // { title: "환불 관리", link: "/Refund/History" },
    { title: '게시판 관리', link: '/Board/Notice' },
    { title: '문의 관리', link: '/Manage/Inquiry' },
    // { title: "결제내역관리", link: "/Payment/History/Complete" },
  ];
  //Left Sub Gnb Array
  const subSetting = isCurrentSubAdmin
    ? [{ title: '내 정보 변경', link: '/Setting/Manager/My', depth: 'depth1 last' }]
    : [
        { title: '운영자 관리', link: '/Setting/Manager', depth: 'depth1' },
        { title: '관리자 계정 관리', link: '/Setting/Manager/Admin', depth: 'depth2' },
        // { title: "부관리자 계정 관리", link: "/Setting/Manager/SubAdmin", depth: "depth2 last" },
      ];
  const subMember = [
    { title: '회원 관리', link: '/Member', depth: 'depth1' },
    { title: '회원 목록', link: '/Member/MemberManage', depth: 'depth2' },
    // { title: "탈퇴 회원 관리", link: "/Member/MemberLeave", depth: "depth2" },
  ];
  const subProduct = [
    // { title: "카테고리 관리", link: "Product/Category", depth: "depth1" },
    // { title: "카테고리 관리", link: "Product/Category/CategoryManage", depth: "depth2" },
    // { title: "일반 패키지", link: "Product/Category/Package", depth: "depth2" },
    // { title: "이벤트 패키지", link: "Product/Category/EventPackage", depth: "depth2" },
    // { title: "추천시술 관리", link: "Product/Recommend", depth: "depth1" },
    // { title: "포인트 상품 관리", link: "Product/PointProduct", depth: "depth1" },
  ];

  const subReserve = [
    // { title: "예약 관리", link: "Reserve", depth: "depth1" },
    // { title: "예약신청/완료", link: "Reserve/ReserveList", depth: "depth2" },
    // { title: "방문완료", link: "Reserve/VisitList", depth: "depth2" },
    // { title: "예약취소", link: "Reserve/CancelList", depth: "depth2" },
  ];

  const subBoard = [
    { title: '게시판 관리', link: '/Board/', depth: 'depth1' },
    { title: '공지사항 목록', link: '/Board/Notice', depth: 'depth2' },
    { title: 'FAQ 목록', link: '/Board/Faq', depth: 'depth2' },
    // { title: "FAQ 분류 관리", link: "/Board/Faq/Category", depth: "depth2" },
    // { title: "의료진", link: "/Board/Manage/MedicalTeam", depth: "depth2" },
    // { title: "전후사진", link: "/Board/Manage/Picture", depth: "depth2" },
    // { title: "시술후기", link: "/Board/Manage/ProductReview", depth: "depth2" },
    // { title: "칭찬불만", link: "/Board/Manage/Review", depth: "depth2" },
    // { title: "채팅문의", link: "/Board/Manage/Chatting", depth: "depth2" },
  ];

  const subInquiry = [
    { title: '문의 관리', link: '/Manage/Inquiry', depth: 'depth1' },
    { title: '1:1 문의 관리', link: '/Manage/Inquiry', depth: 'depth2' },
    // 상담 신청이 데이터몬으로 이관되어 신규 접수가 쌓이지 않아 메뉴에서 내림 (과거 이력은 DB에 남아 있음)
    // { title: "상담 신청 목록", link: "/Manage/Consult", depth: "depth2" },
  ];

  const subPayment = [
    // { title: "결제내역", link: "Payment/History", depth: "depth1" },
    // { title: "결제내역", link: "Payment/History/All", depth: "depth2" },
    // { title: "결제완료", link: "Payment/History/Complete", depth: "depth2" },
    // { title: "결제취소/실패", link: "Payment/History/Cancel", depth: "depth2" },
  ];

  const subRefund = [
    // { title: "키워드 환불 신청", link: "Refund/History", depth: "depth1" },
    // { title: "포인트 환불 신청", link: "Refund/History", depth: "depth2" },
  ];
  const isGnbSelected = useCallback(
    (link) => {
      const selectedLink = link.startsWith('/') ? link : `/${link}`;

      if (pathName === '/' && selectedLink.startsWith('/Member')) return true;
      if (selectedLink.startsWith('/Member')) return pathName.startsWith('/Member');
      if (selectedLink.startsWith('/Board')) return pathName.startsWith('/Board');
      if (selectedLink.startsWith('/Manage')) return pathName.startsWith('/Manage');
      return pathName.startsWith(selectedLink);
    },
    [pathName],
  );

  const isSubSelected = useCallback(
    (v) => {
      if (v.depth.includes('depth1')) {
        return isGnbSelected(v.link);
      }

      if (v.link === '/Board/Faq') {
        return pathName === v.link || pathName.startsWith('/Board/Faq/Write');
      }

      return pathName === v.link || pathName.startsWith(`${v.link}/`);
    },
    [isGnbSelected, pathName],
  );

  const renderGnb = useCallback(() => {
    return gnbData.map((v, idx) => {
      return (
        <NavLink to={v.link} key={idx} className={() => `link ${isGnbSelected(v.link) ? 'active' : ''}`}>
          {v.title}
        </NavLink>
      );
    });
  }, [isGnbSelected]);
  const renderSub = useCallback(() => {
    let arr = [];
    if (isLoginPage) {
      return <></>;
    } else if (pathName === '/' || pathName.startsWith('/Member')) {
      arr = subMember;
    } else if (pathName.startsWith('/Board')) {
      arr = subBoard;
    } else if (pathName.startsWith('/Manage')) {
      arr = subInquiry;
    } else if (pathName.startsWith('/Setting')) {
      arr = subSetting;
    } else if (pathName.startsWith('/Product')) {
      arr = subProduct;
    } else if (pathName.startsWith('/Reserve')) {
      arr = subReserve;
    } else if (pathName.startsWith('/Payment')) {
      arr = subPayment;
    } else if (pathName.startsWith('/Refund')) {
      arr = subRefund;
    } else {
      return <></>;
    }

    return (
      <div className="gnb_sub_wrap">
        <NavLink to="/Member/MemberManage" className="logo">
          {/* <h1>ALAN</h1> */}
          <img src={Logo} className="img" alt="logo" />
          <div style={{ letterSpacing: '5px', marginLeft: '5px' }}>Back Office</div>
        </NavLink>
        <div className="list">
          {arr.map((v, idx) => {
            return (
              <NavLink to={v.link} key={idx} className={() => `link ${v.depth} ${isSubSelected(v) ? 'active' : ''}`}>
                {v.title}
              </NavLink>
            );
          })}
        </div>
      </div>
    );
  }, [pathName, isSubSelected, subSetting]);

  const handleLogout = useCallback(
    (e) => {
      e.preventDefault();
      localStorage.removeItem('adminSession');
      localStorage.removeItem('isLoggedIn');
      navigate('/Login', { replace: true });
    },
    [navigate],
  );

  return (
    <header className={`adm_head  ${isLoginPage ? `isHideGnb` : ``}`}>
      <section className="gnb_wrap">
        <div className="adm_com_center_wrap">
          <section className="gnb_list">{renderGnb()}</section>
          <section className="menu_list">
            {!isLoginPage && (
              <>
                <a href={frontWebUrl} className="link" target="_blank" rel="noopener noreferrer">
                  웹사이트 이동
                </a>
                {isAuthenticated && (
                  <NavLink to={isCurrentSubAdmin ? '/Setting/Manager/My' : '/Setting/Manager/Admin'} className="link">
                    {isCurrentSubAdmin ? '내 정보 변경' : '운영자 관리'}
                  </NavLink>
                )}
                {isAuthenticated && (
                  <NavLink to="/Login" className="link" onClick={handleLogout}>
                    로그아웃
                  </NavLink>
                )}
                {/* <NavLink to="/Login" className="link" onClick={() => { setGnbIdx(0); }}>로그인</NavLink> */}
              </>
            )}
          </section>
        </div>
      </section>
      {renderSub()}
    </header>
  );
}

export default Header;
